module.exports = __webpack_public_path__ + "img/pic18.7b00d445.jpg";